export const adjustStringAnchor = (props: string) => {
  props = props.replace(/[.,\/#!$%\^&\*;:{}?=\-`~()]/g, "");
  var output = "";
  for (var i = 0; i < props.length; i++) {
    if (props.charAt(i) === " " || props.charAt(i) === "_") {
      output += "-";
    } else if (props.charCodeAt(i) <= 127) {
      output += props.charAt(i);
    }
  }
  return output.toLowerCase();
};
